/** Renders a platform article's paragraphs; a paragraph made of "- " lines
 *  becomes a bullet list. */
export default function ArticleBody({ body }: { body: string[] }) {
  return (
    <>
      {body.map((para, i) => {
        const lines = para.split("\n");
        if (lines.every((l) => l.startsWith("- "))) {
          return (
            <ul key={i}>
              {lines.map((l, j) => (
                <li key={j}>{l.slice(2)}</li>
              ))}
            </ul>
          );
        }
        return <p key={i}>{para}</p>;
      })}
    </>
  );
}
